import { useRef, useState } from 'react';
import { Drawer } from '@navi/web-ui/lib/primitives';
import ConfigurationForm from '.';
import { AddConfigurationDrawerProps } from '../types';
import ConfigurationDrawerFooter from './ConfigurationDrawerFooter';
import { isFunction } from '@cp/src/utils/commonUtils';

const AddConfigurationDrawer = (props: AddConfigurationDrawerProps) => {
  const { isDrawerOpen, onClose, onSuccess, handleQueryCopy, configurationData } = props;
  const formRef = useRef<any>(null);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);

  const handleSubmitClick = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  const handleQueryCopyClick = () => {
    if (formRef.current && isFunction(formRef.current.getFormData)) {
      const formData = formRef.current.getFormData();
      handleQueryCopy(formData);
    }
  };

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={onClose}
      headerText="Add New Configuration"
      showHeaderDivider={true}
      contentClasses="overflow-auto"
      className="!w-[400px]"
      footerContainerClasses="!px-0 !pt-2"
      footer={
        <ConfigurationDrawerFooter
          onClose={onClose}
          onSubmit={handleSubmitClick}
          onQueryCopy={handleQueryCopyClick}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
        />
      }
    >
      <ConfigurationForm
        ref={formRef}
        isDrawerOpen={isDrawerOpen}
        onClose={onClose}
        onSuccess={onSuccess}
        setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
        configurationData={configurationData}
      />
    </Drawer>
  );
};

export default AddConfigurationDrawer;
